"use client";

import { createContext, useCallback, useContext, useEffect, useState } from "react";

export type Theme = "dark" | "light";
const COOKIE = "VISERA_THEME";

function readInitial(): Theme {
  if (typeof document !== "undefined") {
    const v = document.documentElement.getAttribute("data-theme");
    if (v === "light" || v === "dark") return v;
  }
  return "dark";
}

const Ctx = createContext<{ theme: Theme; toggle: () => void }>({ theme: "dark", toggle: () => {} });

export function useTheme() {
  return useContext(Ctx);
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>(readInitial);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document.cookie = `${COOKIE}=${theme}; path=/; max-age=31536000; samesite=lax`;
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);

  return <Ctx.Provider value={{ theme, toggle }}>{children}</Ctx.Provider>;
}

export { themeInitScript } from "@/lib/theme-script";
